module.exports = __webpack_public_path__ + "img/light-mud-decal-18.c4d3964b.png";